<template>
	<div>
		<vx-tooltip :text="getToolTipText()">
			<vs-button id="shipOrders" class="vs-con-loading__container" color="success" @click.native="shipOrdersDialog"
					   :disabled="isButtonDisabled()">
				<font-awesome-icon :icon="['fas', 'truck']" class="fa-icon" />
			</vs-button>
		</vx-tooltip>

		<vs-popup :title="this.shipPopup.selectedOrders.length + ' bestellingen verzenden'" :active.sync="shipPopup.visible"
				  fullscreen class="shipOrdersPopup" @onclose="this.reset()">
			<div class="vx-row h-full">
				<div class="vx-col w-full ml-2">
					<div class="vx-row">
						<div class="vx-col w-3/12">
							Bestelnummer
						</div>
						<div class="vx-col w-3/12">
							Verzendadres
						</div>
						<div class="vx-col w-3/12">
							Verzendmethode
						</div>
						<div class="vx-col  w-2/12">
							Track en trace
						</div>
						<div class="vx-col w-1/12" />
					</div>
					<div class="vx-row">
						<div class="vx-col w-3/12">

						</div>
						<div class="vx-col w-3/12">

						</div>
						<div class="vx-col w-3/12">
							<label class="multiselect-label">Verzendmethode voor alle bestellingen</label>
							<vue-multiselect
								v-validate="'required'"
								name="shippingMethod"
								placeholder="Selecteer verzendmethode"
								v-model="shipPopup.shippingMethodAll"
								:options="shipPopup.shippingOptions"
								:show-labels="false"
								:allow-empty="false"
								:danger-text="errors.first('shippingForm.shippingMethod')"
								:danger="errors.has('shippingForm.shippingMethod')"
								label="text"
								track-by="value"
							/>
						</div>
						<div class="vx-col w-2/12">

						</div>
						<div class="vx-col w-1/12" />
					</div>

					<div class="vx-row" v-for="selectedOrder in this.shipPopup.selectedOrders" :key="selectedOrder.order.id"
						 :class="selectedOrder.saved ? 'bg-success-soft' : selectedOrder.failed ? 'bg-danger-soft' : ''">
						<div class="vx-col w-3/12 flex items-center">
							<div class="flex pr-5">
								<img v-if="selectedOrder.order.order.type === 1" src="@/assets/images/orders/types/bol.png" alt="content-img" style="max-height: 40px">
								<img v-if="selectedOrder.order.order.type === 2" src="@/assets/images/orders/types/lightspeed.png" alt="content-img" style="max-height: 40px">
							</div>

							<div class="flex">
								{{ selectedOrder.order.order.type_id_visible }}
							</div>
						</div>
						<div class="vx-col w-3/12 text-sm pt-1 pb-1">
							<p v-if="selectedOrder.order.shipping.company">
								{{ selectedOrder.order.shipping.company }}
							</p>
							{{ selectedOrder.order.shipping.full_name }}<br>
							{{ selectedOrder.order.shipping.full_address }}<br>
							{{ selectedOrder.order.shipping.zip_code }} {{ selectedOrder.order.shipping.city }}<br>
							<p v-if="selectedOrder.order.shipping.country_code === 'NL'">
								Nederland
							</p>
							<p v-if="selectedOrder.order.shipping.country_code === 'BE'">
								België
							</p>
						</div>
						<div class="vx-col w-3/12 pt-1">
							<label class="multiselect-label">Verzendmethode</label>
							<vue-multiselect
								v-validate="'required'"
								name="shippingMethod"
								placeholder="Selecteer verzendmethode"
								v-model="selectedOrder.shippingMethod"
								:options="shipPopup.shippingOptions"
								:show-labels="false"
								:allow-empty="false"
								:danger-text="errors.first('shippingForm.shippingMethod')"
								:danger="errors.has('shippingForm.shippingMethod')"
								label="text"
								track-by="value"
								:disabled="selectedOrder.loading"
								style="z-index: initial"
							/>
						</div>
						<div class="vx-col w-2/12 pt-1">
							<vs-input label="Track & trace nummer" v-model="selectedOrder.tracking" :disabled="selectedOrder.loading" />
						</div>
						<div class="vx-col w-1/12 flex items-center">
							<font-awesome-icon :icon="['fas', 'sync-alt']" class="fa-icon fa-spin" v-if="selectedOrder.loading" />
							<font-awesome-icon :icon="['fas', 'check']" class="fa-icon" v-if="selectedOrder.saved" />
							<font-awesome-icon :icon="['fas', 'times-circle']" class="fa-icon" v-if="selectedOrder.failed" />
						</div>
					</div>
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-button class="float-right m-2" color="danger" type="border" @click.native="shipPopup.visible = false">Annuleren</vs-button>
							<vs-button class="float-right m-2" color="primary" type="filled" @click.native="shipOrders">Verzenden</vs-button>
						</div>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>

import apiClient from '../../services/apiClient';

export default {
	data() {
		return {
			shipPopup: {
				visible: false,
				shippingMethodAll: null,
				shippingOptions: [],
				selectedOrders: [],
			}
		}
	},
	computed: {
		shippingOptions() {
			return this.$store.state.sendOptions.deliveryOptions;
		}
	},
	watch: {
		'shipPopup.visible'(visible) {
			if (!visible) {
				this.stopLoading();
				this.reset();
			}
		},
		'shipPopup.shippingMethodAll'(shippingMethod) {
			this.shipPopup.selectedOrders.forEach(selectedOrder => {
				selectedOrder.shippingMethod = shippingMethod;
			});
		}
	},
	methods: {
		reset() {
			this.shipPopup.shippingMethodAll = null;
		},
		getToolTipText() {
			if (this.$parent.getSelectedOrdersCount() === 0) {
				return 'Er is geen bestelling geselecteerd'
			}
			if (this.$parent.getSelectedOrdersCount() === 1) {
				return 'Verzend bestelling';
			}

			return 'Verzend bestellingen';
		},
		isButtonDisabled() {
			return this.$parent.getSelectedOrdersCount() === 0;
		},
		async shipOrdersDialog() {
			await this.startLoading();

			this.shipPopup.selectedOrders = [];

			this.$parent.getSelectedOrders().forEach(order => {
				const shippingData = {
					order,
					shippingMethod: null,
					tracking: null,
					loading: false,
					saved: false,
					failed: false,
				};

				this.shipPopup.selectedOrders.push(shippingData);
			});

			this.shipPopup.shippingOptions = [];

			for (const shippingOption in this.shippingOptions) {
				if (this.shippingOptions.hasOwnProperty(shippingOption)) {
					if (this.shippingOptions[shippingOption]) {
						this.shipPopup.shippingOptions.push({
							text: this.getShippingOptionName(shippingOption),
							value: shippingOption
						})
					}
				}
			}

			this.shipPopup.visible = true;
		},
		async shipOrders() {
			this.shipPopup.selectedOrders.forEach(selectedOrder => {
				if (!selectedOrder.saved) {
					selectedOrder.loading = true;
					selectedOrder.failed = false;
				}
			});

			this.shipPopup.selectedOrders.forEach(selectedOrder => {
				if (!selectedOrder.saved) {
					try {
						this.shipOrder(selectedOrder);
					} catch {
						selectedOrder.loading = false;
						selectedOrder.failed = true;
					}
				}
			});
		},
		shipOrder(selectedOrder) {
			const params = {
				order_id: selectedOrder.order.order.id,
				ship: true,
				transporter_code: selectedOrder.shippingMethod.value,
			};

			if (selectedOrder.tracking && selectedOrder.tracking !== '') {
				params.track_and_trace = selectedOrder.tracking;
			}

			apiClient.put('orders/update', params).then(response => {
				selectedOrder.loading = false;
				selectedOrder.saved = true;
				selectedOrder.failed = false;

				this.closePopup();

				setTimeout(() => {
					this.$store.dispatch('openOrdersStore/removeOrder', response.data);
				}, 500);

			}).catch(error => {
				selectedOrder.loading = false;
				selectedOrder.failed = true;

				this.$vs.notify({
					title: 'Oops!',
					text: 'Het verzenden van bestelling #' + this.order.order.type_id_visible + ' is mislukt',
					color: 'danger'
				});
			});
		},
		closePopup() {
			const notShippedOrders = this.shipPopup.selectedOrders.filter(selectedOrder => {
				return !selectedOrder.saved;
			});
			if (notShippedOrders.length === 0) {
				this.shipPopup.visible = false;
			}
		},
		startLoading() {
			this.$vs.loading({
				container: '#shipOrders',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#shipOrders > .con-vs-loading')
		},
		getShippingOptionName(shippingOption) {
			const shippingOptions = {
				BRIEFPOST: 'Briefpost',
				UPS: 'UPS',
				TNT: 'PostNL',
				TNT_EXTRA: 'PostNL extra@home',
				TNT_BRIEF: 'PostNL Briefpost',
				TNT_EXPRESS: 'TNT Express',
				DYL: 'Dynalogic',
				DPD_NL: 'DPD Nederland',
				DPD_BE: 'DPD België',
				BPOST_BE: 'Bpost België',
				BPOST_BRIEF: 'Bpost Briefpost',
				DHLFORYOU: 'DHLFORYOU',
				GLS: 'GLS',
				FEDEX_NL: 'FedEx Nederland',
				FEDEX_BE: 'FedEx Belgie',
				OTHER: 'Anders',
				DHL: 'DHL',
				DHL_DE: 'DHL Germany',
				DHL_GLOBAL_MAIL: 'DHL Global mail',
				TSN: 'Transportservice Nederland',
				FIEGE: 'Fiege',
				TRANSMISSION: 'TransMission',
				PARCEL_NL: 'Parcel.nl',
				LOGOIX: 'LogoiX',
				PACKS: 'Packs',
				COURIER: 'Bezorgafspraak',
				RJP: 'NedWRK(Red je pakketje)',
			};

			return shippingOptions[shippingOption];
		},
	}
}
</script>

<style>
.shipOrdersPopup {
	z-index: 300001;
}

.vs-popup--content {
	height: 100%;
}
</style>
